import { Tab } from "./tab";

type TabsArray = Array<Tab>;

export class Menu {
    static find_properties: TabsArray = [
		{
			id: 1,
			name: 'for-sale',
			url: '/dijual',
		},
		{
			id: 2,
			name: 'for-rent',
			url: '/disewa',
		},
	];

	static info_property: TabsArray = [
		{
			id: 4,
			name: 'article',
			url: '/info-properti',
		},
		{
			id: 5,
			name: 'kpr-simulation',
			url: '/simulasi-kpr',
		},
	];

	static businesses: TabsArray = [
		{
			id: 6,
			name: 'property-consultant',
			url: '/property-consultant',
		},
		{
			id: 7,
			name: 'partnership-opportunity',
			url: '/peluang-kemitraan',
		},
		
	];

	

	static about_uses: TabsArray = [
		{
			id: 8,
			name: 'about-ljhrealty',
			url: '/tentang-kami',
		},
		{
			id: 9,
			name: 'outlet-list',
			url: '/daftar-outlet',
		}
	];
}
